"use strict";
exports.__esModule = true;
exports.TypedEventEmitterV3 = void 0;
var events_1 = require("events");
/**
 * Simple typed event emitter, will extract to @moopsyjs/utils eventually
 */
var TypedEventEmitterV3 = /** @class */ (function () {
    function TypedEventEmitterV3() {
        var _this = this;
        this.emit = function (event, data) {
            _this.emitter.emit(event, data);
        };
        this.on = function (event, cb) {
            _this.emitter.on(event, cb);
        };
        this.once = function (event, cb) {
            _this.emitter.once(event, cb);
        };
        this.off = function (event, cb) {
            _this.emitter.off(event, cb);
        };
        this.emitter = new events_1.EventEmitter;
    }
    return TypedEventEmitterV3;
}());
exports.TypedEventEmitterV3 = TypedEventEmitterV3;
